<template>
  <div class="account">
    <app-title title="Account"/>

    <div class="row">
      <div class="col-md-3 p-md-3 text-center">
        <img class="header-logo" src="/images/logo.png">
      </div>
      <div class="col-md-7 content-middle dashboard-row p-md-3 mt-md-3">
        <router-link class="link" to="/dashboard">
          <font-awesome-icon class="font-awesome-icon" icon="arrow-circle-left"/>
          Dashboard
        </router-link>
      </div>
      <div class="col-md-3 sidebar-account p-md-3">
        <app-logout/>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3 d-none d-sm-block"></div>
      <div class="col-md-7 content-middle main">
        <div class="title">
          {{ userName }}
        </div>
      </div>
      <div class="col-md-3 d-none d-sm-block"></div>
    </div>

    <div class="row">
      <div class="col-md-3 p-md-3 d-none d-sm-block"></div>
      <div class="col-md-7 content-middle p-md-3">
        <div class="sub-title">Accountgegevens</div>
        <div class="card">
          <div class="card-body">
            <div v-if="accountData" class="col-md-13">
              <div class="row pb-md-3">
                <div class="col-md-6">
                  <app-personal-details :accountData="accountData"/>
                  <app-company-details :accountData="accountData"/>
                </div>

                <div class="col-md-6">
                  <app-login-details :accountData="accountData"/>
                  <app-password-details/>
                </div>
              </div>

              <hr/>

              <div class="row pt-md-3 pb-md-3">
                <div class="col-md-6">
                  <app-delivery-details :accountData="accountData"/>
                </div>
                <div class="col-md-6">
                  <app-invoice-details :accountData="accountData"/>
                </div>
              </div>
              <hr/>

              <div class="row pt-md-3">
                <div class="col-md-6">
                  <app-opening-hours-details :accountData="accountData"/>
                </div>
                <div class="col-md-6">
                  <app-unloading-details :accountData="accountData"/>
                </div>
              </div>
            </div>
            <div v-else>
              <font-awesome-icon class="font-awesome-icon" icon="spinner" spin/>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 p-md-3 d-none d-sm-block"></div>
    </div>
  </div>
</template>

<script>
  import PersonalDetails from '@/components/Account/Details/PersonalDetails.vue'
  import LoginDetails from '@/components/Account/Details/LoginDetails.vue'
  import CompanyDetails from '@/components/Account/Details/CompanyDetails.vue'
  import DeliveryDetails from '@/components/Account/Details/DeliveryDetails.vue'
  import InvoiceDetails from '@/components/Account/Details/InvoiceDetails.vue'
  import OpeningHoursDetails from '@/components/Account/Details/OpeningHoursDetails.vue'
  import UnloadingDetails from '@/components/Account/Details/UnloadingDetails.vue'
  import PasswordDetails from '@/components/Account/Details/PasswordDetails.vue'
  import Logout from '@/components/Auth/Logout.vue'

  import { FETCH_ACCOUNT_DATA } from '../store/types'

  export default {
    name: 'account',
    components: {
      'app-personal-details': PersonalDetails,
      'app-login-details': LoginDetails,
      'app-password-details': PasswordDetails,
      'app-company-details': CompanyDetails,
      'app-delivery-details': DeliveryDetails,
      'app-invoice-details': InvoiceDetails,
      'app-opening-hours-details': OpeningHoursDetails,
      'app-unloading-details': UnloadingDetails,
      'app-logout': Logout
    },
    computed: {
      accountData() {
        return !this.$store.getters.accountData ? false : this.$store.getters.accountData
      },
      userName() {
        return !this.$store.getters.user.name ? false : this.$store.getters.user.name
      }
    },
    created() {
      this.$store.dispatch(FETCH_ACCOUNT_DATA)
    }
  }
</script>

<style lang="scss">
  .details-title {
    font-size: 1.1em;
    margin-bottom: 0.5rem;
    margin-top: 0;
    font-weight: 500;
    line-height: 1.2;
  }

  .card-body.card-account {
    padding: 10px;
    color: $dark-grey;
    font-weight: bold;

    .link {
      font-weight: normal;
    }
  }
</style>
